import { PieChart as RechartsPieChart } from 'recharts';

export const PieChart = (
    props: React.ComponentProps<typeof RechartsPieChart>
) => {
    return (
        <RechartsPieChart data-testid={'PieChart-container'} {...props} />
    );
};

export default PieChart;
